import { Component, Input } from '@angular/core';
import { to64decode } from 'src/app/helpers/base64';
import { getLanguageCookie } from 'src/assets/language';
import { MatTableDataSource } from '@angular/material/table';
import { v4 } from "uuid";
import { addAlert, apiOfflineAsync, setValueById } from "../../../../layouts/pages/pages.component";
import { asyncForEach } from "../../../../helpers/asyncForEach";
import { invertDate } from "../../../../helpers/invertDate";
import * as moment from "moment";
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
@Component({
  selector: 'app-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss']
})
export class IndicatorsComponent {
  @Input() parameters: any = {}
  @Input() dimensions: any = {}

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  dataSource!: MatTableDataSource<any>;
  displayedColumns: string[] = ['name', 'action'];
  currentPage = 1;
  currentPageReq = 1;
  itemsPerPage = 10;

  frequencyArray: any = []
  searchFrequency: string = '';
  selectedFrequency: any = {
    name: {
    }
  }

  createFrequency: boolean = false
  newFrequency: any = {
    name: ''
  }

  is_new_indicator: boolean = true;

  currentIndicator: any = {}


  constructor(private corporationService: CorporationService) {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit() {
    this.dataSource.data = this.parameters.item.indicators ?? []
    await this.getCorporationTypeFrequency()
  }

  getNames(name: any) {
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  getCurrentLanguage() {
    return to64decode(localStorage.getItem('language'))?.lang
  }

  getFrequencyName(frequency: string | null): string {
    if (!frequency) return this.getLanguages('search')

    const typeFrequency = this.frequencyArray.find((t: { uuid?: string; slug?: string }) => t.uuid === frequency) ||
      this.frequencyArray.find((t: { uuid?: string; slug?: string }) => t.slug === frequency)

    if (typeFrequency?.uuid) return typeFrequency.name
    else if (typeFrequency?.slug) return this.getNames(typeFrequency.name)
    else return this.getLanguages('search')
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  isData() {
    return this.dataSource.data.length > 0
  }

  getDisplayedRows(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dataSource.data.slice(startIndex, endIndex);
  }

  getColumns() {
    return this.displayedColumns.slice(1)
  }

  getItemsPerPage() {
    return this.itemsPerPage
  }

  getCurrentPages(): number {
    return this.currentPage
  }

  choseItemsPage(number: number) {
    this.itemsPerPage = number;
    this.getDisplayedRows()
  }

  onPageChange(newPage: number, text: string): void {
    this.currentPage = newPage;
  }

  getTotalPages(): number {
    return Math.ceil(this.dataSource.data.length / this.itemsPerPage);
  }

  async checkValue() {
    let total = this.getTotalPages()
    if (this.currentPage > total) this.currentPage = total;
  }

  choseItemSelect(type: string, value: any, item: any) {
    switch (type) {
      case 'frequency':
        // this.selectedFrequency = value;
        // item.frequency = value.slug;

        if (value.name == "New +") {
          this.createFrequency = true;
          return
        }
        item.frequency = value.uuid ? value.uuid : value.slug
        break;
      default:
        break;
    }
  }


  async formatDate(property: any) {
    // @ts-ignore
    let value = document.getElementById(`indicators_${property}`).value
    let formattedValue = value.replace(/\D/g, "");

    const maxLength = 8;

    if (formattedValue.length > maxLength) {
      formattedValue = formattedValue.substr(0, maxLength);
    }

    this.currentIndicator[property] = null

    let day = moment().format('DD')
    if (formattedValue.length >= 0) {
      day = formattedValue.substr(0, 2)
      value = `${day}`
    }

    let month = moment().format('MM')
    if (formattedValue.length >= 2) {
      month = formattedValue.substr(2, 2)
      value += `/${month}`
    }

    let year = moment().format('YYYY')
    if (formattedValue.length >= 4) {
      year = formattedValue.substr(4, 4)
      value += `/${year}`
    }
    setValueById(`indicators_${property}`, value)

    if (formattedValue.length >= 8) this.currentIndicator[property] = value;
  }

  async selectIndicator(item: any) {
    this.currentIndicator = { ...item }
    this.is_new_indicator = false;
    this.selectedFrequency = { name: '' }

    // this.frequencyArray.forEach((frequency:any) => {
    //   if(frequency.slug == item.frequency){
    //     this.selectedFrequency = frequency
    //   }
    // });

    await asyncForEach(['start_date', 'end_date'], async (property: string) => {
      setValueById(`indicators_${property}`, await invertDate(this.currentIndicator[property], 'br'))
    })
  }

  async newIndicator() {
    this.selectedFrequency = { name: '' }
    this.currentIndicator = {
      uuid: v4(),
      name: '',
      absolute: '',
      maximum: '',
      minimum: '',
      average: '',
      frequency: '',
      start_date: '',
      end_date: '',
      description: '',
      technical_script: ''
    };

    setValueById('indicators_start_date')
    setValueById('indicators_end_date')
    this.is_new_indicator = true;
  }

  async saveIndicator() {
    let inputs: any = []

    if (!this.parameters.isEdit) {
      return
    }

    if (!this.currentIndicator.name || this.currentIndicator.name == '') {
      inputs.push('Name')
    }

    if (inputs.length > 0) {
      addAlert('orange', `${this.getLanguages('mandatoryField')}${inputs.join(`, `)}`)
      return
    }

    if (this.is_new_indicator) {
      this.dataSource.data.push(this.currentIndicator)
    } else {
      this.dataSource.data.find((item: any, index: number) => {
        if (item.uuid == this.currentIndicator.uuid) {
          this.dataSource.data[index] = this.currentIndicator
        }
      })
    }

    await this.setIndicatorDate()
    await this.newIndicator()
  }

  async setIndicatorDate(type: string = 'us') {
    await asyncForEach(this.dataSource.data, async (item: any, index: number) => {
      this.dataSource.data[index] = await this.setIndicatorDateValue(type, item)
    })
  }

  async setIndicatorDateValue(type: string = 'us', item: any, properties = ['start_date', 'end_date']) {
    await asyncForEach(properties, async (property: any) => {
      if (item[property]) item[property] = await invertDate(item[property])
    })
    return item
  }

  async setClearInputDate(property: string) {
    this.currentIndicator[property] = null
    setValueById(`indicators_${property}`)
  }

  async deleteIndicator(uuid: string) {
    this.dataSource.data = this.dataSource.data.filter(item => item.uuid !== uuid);
    this.parameters.item.indicators = this.dataSource.data
    await this.newIndicator()
  }

  getSystemPermission(screen: string, action: string) {
    return systemPermissionsNew(screen, action)
  }

  async getCorporationTypeFrequency(event?: any) {
    try {
      const response: any = await this.corporationService.getCorporationTypeFrequency();
      if (response && response.data) {
        let tempArray = response.data
        tempArray = tempArray.filter((item: any) => item.name && item.uuid)
          .map((item: any) => ({
            name: item.name,
            uuid: item.uuid
          }))
        this.frequencyArray = [...this.parameters.optionsArray.attachmentsTypeEnum, ...tempArray];

        if (this.getSystemPermission('business_solutions', 'create_type_frequency')) {
          this.frequencyArray.unshift({ name: 'New +' })
        }
      } else {
        throw new Error('Erro ao consultar tipos de anexos!\nConsulta o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async setCorporationTypeFrequency() {
    let flag = false;

    this.frequencyArray.forEach((item: any) => {
      if (item.name == this.newFrequency.name) {
        addAlert('orange', this.getLanguages('businessSolution/modal/rules/errors/typeFrequency'))
        flag = true
        return
      }
    });

    if (flag) {
      return
    }

    if (this.newFrequency.name == 'New +') {
      addAlert('danger', this.getLanguages('auth/alert/nameReservedWord'))
      return
    }

    try {
      const response: any = await this.corporationService.setCorporationTypeFrequency(this.newFrequency);
      if (response && [201, 202].includes(response.status)) {
        addAlert('success', response.message)
        await this.getCorporationTypeFrequency();
      } else {
        addAlert('danger', response.message)
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.createFrequency = false;
    this.newFrequency.name = ''
  }
}
